import { AxiosError } from 'axios'
import { defaultAssinaturaDigitalErrorMessage } from 'hooks/assinatura-digital/model-assinaturaDigitalPopup'

export const getAssinaturaDigitalRequestErrorMessage = (error?: AxiosError<string>): React.ReactNode =>
  error?.response?.status === 400 ? error.response.data : defaultAssinaturaDigitalErrorMessage
